import PropTypes from "prop-types";
import { StyledCloseBtn } from "../../styles/StyledCloseBtn";

export default function CloseBtn({ onClick, icon, modal, small }) {
	return (
		<StyledCloseBtn onClick={onClick} modal={modal} small={small}>
			<img src={icon} alt="Close" role="img" />
		</StyledCloseBtn>
	);
}

CloseBtn.propTypes = {
	icon: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired,
	modal: PropTypes.bool,
	small: PropTypes.bool,
};

CloseBtn.defaultProps = {
	modal: false,
	small: false,
};
